import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'promotion_config',
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    menuList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      commonValue: {
        category_id: ''
      },
      menuListFilter: []
    };
  },
  methods: {
    addItem: function addItem() {
      if (this.value.config.value.length >= 10) {
        this.$message.error('最多增加10条活动');
        return;
      }
      this.value.config.value.push(_objectSpread({}, this.commonValue));
    },
    handleDelUpload: function handleDelUpload(index) {
      var _this = this;
      this.$confirm("\u786E\u5B9A\u8981\u5220\u9664\u6D3B\u52A8".concat(index + 1, "\u5417"), '提示', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(function () {
        _this.value.config.value.splice(index, 1);
      }).catch(function () {});
    }
  },
  created: function created() {
    this.menuListFilter = this.menuList.filter(function (i) {
      return i.is_promotion + '' === '1';
    });
    this.$set(this.value, 'config', _objectSpread({
      margin_top: 15,
      //兼容新老组件 默认预置15px
      z_index: 2,
      //兼容新老组件 默认预置2
      value: [_objectSpread({}, this.commonValue)]
    }, this.value.config));
  }
};